// src/components/form/FormNavButtons.js

import { useTranslation } from "react-i18next";

/**
 * FormNavButtons
 * --------------
 * Re-usable navigation strip for any multi-step “wizard”.
 *
 * Props
 * -----
 * • `hasPrev` (bool)   – Show the “Previous” button when `true`.
 * • `onPrev` (fn)      – Callback fired on Previous click.
 * • `onNext` (fn)      – Callback fired on Next / Confirm click.
 * • `isLast` (bool)    – When `true` the primary button shows “Confirm”.
 *
 * Notes
 * • Purely presentational – no internal state or side-effects.
 * • Keeps button styling/markup in one place so different forms don’t
 *   duplicate the same flex/spacing logic.
 */
export default function FormNavButtons({ hasPrev, onPrev, onNext, isLast }) {
  const { t } = useTranslation();
  return (
    <div className="flex justify-between mt-6">
      {hasPrev ? (
        <button type="button" onClick={onPrev} className="outlined-button">
          {t("formNavButtons.previous")}
        </button>
      ) : (
        <span /> /* keeps grid alignment when first step */
      )}

      <button type="button" onClick={onNext} className="primary-button">
        {isLast ? t("formNavButtons.confirm") : t("formNavButtons.next")}
      </button>
    </div>
  );
}
